export const typesJetFly = {
    GET_JET_FLY_SUCCESS:'GET_JET_FLY_SUCCESS',
    GET_JET_FLY_ERROR:'GET_JET_FLY_ERROR',
    GET_JET_FLY_BEGIN:'GET_JET_FLY_BEGIN'
}

